import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CellEditorDirective } from './cell-editor.directive';
import { CellEditorService } from './cell-editor.service';

@Component({
    selector: 'mat-cell-editor',
    templateUrl: './cell-editor.component.html',
    styleUrls: [ './cell-editor.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellEditorComponent implements OnInit, OnDestroy {

    private observeSubscription: Subscription;

    constructor(private myCellEditorService: CellEditorService,
                private myChangeDetectorRef: ChangeDetectorRef,
                private myCellEditorDirective: CellEditorDirective,
    ) {}

    public get isEditing(): boolean {
        return this.myCellEditorService.editingCell === this.myCellEditorDirective.myElementRef.nativeElement;
    }

    public ngOnInit(): void {
        this.observeSubscription = this.myCellEditorService.observeChangeDetection().subscribe(() => this.myChangeDetectorRef.markForCheck());
    }

    public ngOnDestroy(): void {
        this.observeSubscription?.unsubscribe();
    }

}
